import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import RefreshIcon from 'icons/RefreshButton/Refresh';
import { useMsal } from '@azure/msal-react';
import { formatDate } from 'helpers/DateFormatter';
import { TestEquipmentForm } from './TestEquipmentForm';
import { resetDataForEditTestEquipment, updateDataForEditTestEquipment, PutEditTestEquipmentData, PostAddTestEquipmentData } from './TestEquipmentForm.actions';
import { IsEditMandatory } from './mandatoryFieldsForAddEdit';
import { setCurrentView } from '../../Home/Home.actions';
import { getTestEquipDesc } from './AddTestEquipmentForm';
import { NONMO_USER_ROLE } from 'journeys/portal/Home/Home.constants';

const RefreshFormComponent = ({ buttonHandler }) => <RefreshIcon buttonHandler={buttonHandler} rotate={-90} tooltip="Reset Form" />;
RefreshFormComponent.propTypes = {
    buttonHandler: PropTypes.func.isRequired
};

const EditTestEquipmentForm = (props) => {
    const { setCurrentAppView, resetData, updateFormData, editTestEquipmentData, isMRATOnline,
        putEditTestEquipmentData, bpRegionNameAlias, selectedAssetAliasName, unSavedChangesTE, postAddTestEquipmentData, IsLateEntry } = props;
    const FooterButtonVisible = unSavedChangesTE && IsEditMandatory(editTestEquipmentData);
    const [disableEditTESubmit, setDisableEditTESubmit] = useState(false);
    const showRefreshButton = isMRATOnline;
    const { instance } = useMsal();
    const userName = instance.getActiveAccount();
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);

    const UpdateFormDataHandler = (obj) => {
        const objWithPropertiesToBeUpdated = obj;
        objWithPropertiesToBeUpdated.CreatedBy = editTestEquipmentData.CreatedBy;
        objWithPropertiesToBeUpdated.CreatedDate = editTestEquipmentData.CreatedDate;
        updateFormData(objWithPropertiesToBeUpdated);
    };
    const SubmitButtonHandler = async () => {
        setDisableEditTESubmit(true);
        const newFormedObject = {
            FullEqDesc: getTestEquipDesc(editTestEquipmentData),
            ModifiedBy: userName?.name,
            LastModifiedDate: formatDate(new Date()),
        };
        editTestEquipmentData?.Rowid ? await putEditTestEquipmentData({ ...editTestEquipmentData, ...newFormedObject }) : await postAddTestEquipmentData({ ...editTestEquipmentData, ...newFormedObject });
        setCurrentAppView('testequipment');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => () => resetData(), []);
    const headerText = () => {
        if (IsLateEntry) {
            return `Edit ${NONMO_USER_ROLE.LateEntryUser} Test Equipment`;
        }
        if (isNonMoFeatureEnabled) {
            return `Edit ${NONMO_USER_ROLE.User} Test Equipment`;
        }
        return 'Edit Test Equipment';
    };
    return (
        <SiteWrapper
            headerText={headerText()}
            ButtonSection={showRefreshButton && <RefreshFormComponent buttonHandler={() => resetData()} />}
            footerButtonHandler={SubmitButtonHandler}
            footerButtonText="Submit"
            FooterButtonVisible={FooterButtonVisible}
            goBack="testequipment"
            isDisabled={disableEditTESubmit}
            displayUnsavedChangesPopUp
        >
            <TestEquipmentForm
                formId="EditTestEquipmentForm"
                isEditTestEquipment
                formValues={editTestEquipmentData}
                formHandler={(obj) => UpdateFormDataHandler(obj)}
                bpRegionNameAlias={bpRegionNameAlias}
                selectedAssetAliasName={selectedAssetAliasName}
            />
        </SiteWrapper>
    );
};

const mapStateToProps = ({ AppData, TestEquipment, Home, Forms }) => ({
    editTestEquipmentData: TestEquipment.editTestEquipmentData,
    isMRATOnline: AppData.isMRATOnline,
    trfMasterList: Home.trfMasterList,
    selectedTag: Forms.selectedTag,
    selectedAssetAliasName: Home.selectedAssetAliasName,
    bpRegionNameAlias: Home.bpRegionNameAlias,
    unSavedChangesTE: TestEquipment.unSavedChangesTE,
    IsLateEntry: Home.IsLateEntry
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    setCurrentAppView: (view) => dispatch(setCurrentView(view)),
    resetData: () => dispatch(resetDataForEditTestEquipment()),
    updateFormData: (obj) => dispatch(updateDataForEditTestEquipment(obj)),
    putEditTestEquipmentData: (obj) => dispatch(PutEditTestEquipmentData(obj)),
    postAddTestEquipmentData: (obj) => dispatch(PostAddTestEquipmentData(obj)),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditTestEquipmentForm);

EditTestEquipmentForm.propTypes = {
    bpRegionNameAlias: PropTypes.string,
    editTestEquipmentData: PropTypes.object.isRequired,
    IsLateEntry: PropTypes.bool,
    isMRATOnline: PropTypes.bool.isRequired,
    postAddTestEquipmentData: PropTypes.func.isRequired,
    putEditTestEquipmentData: PropTypes.func.isRequired,
    resetData: PropTypes.func,
    selectedAssetAliasName: PropTypes.string,
    setCurrentAppView: PropTypes.func,
    unSavedChangesTE: PropTypes.bool,
    updateFormData: PropTypes.func,
};
